<template>
<v-container>
  <v-row>
    <v-col>
    <v-card color="primary" dark>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="white"
        show-arrows
        grow
      >
        <v-tabs-slider color="#0897d7"></v-tabs-slider>
        <v-tab
          v-for="item in items"
          :key="item"
        >
          {{ item }}
        </v-tab>
      </v-tabs>

      <!-- TABS -->
      <v-tabs-items v-model="tab">

        <!-- Alarm -->
        <v-tab-item>
          <v-card
            flat
          >
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-container>
                  <v-row class="my-n8">
                    <v-col>
                      <v-select
                        :items="stations"
                        label="Stasiun"
                        v-model="selectStation"
                        return-object
                        :rules="nameRules"
                        @change="change(selectStation)"
                        class="float-right"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      <v-row>
                        <v-col class="mb-n4">
                          <v-text-field
                            v-model="station"
                            :rules="nameRules"
                            label="Station"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="mb-n4">
                          <v-text-field
                            v-model="waspada"
                            :rules="number"
                            label="Batas Waspada"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="mb-n4">
                          <v-text-field
                            v-model="evakuasi"
                            :rules="number"
                            label="Batas Evakuasi"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="mb-n4">
                          <v-text-field
                            v-model="bahaya"
                            :rules="number"
                            label="Batas Bahaya"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="my-n4">
                          <v-text-field
                            v-model="latitude"
                            :rules="nameRules"
                            label="GPS Coordinate Latitude"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="my-n4">
                          <v-text-field
                            v-model="longitude"
                            :rules="nameRules"
                            label="GPS Coordinate Longitude"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="my-n4">
                          <v-combobox
                            v-model="location"
                            :items="locations"
                            label="UPTD PSDA"
                            auto-select-first
                            :rules="locationRequired"
                          >
                          </v-combobox>
                        </v-col>
                      </v-row>

                      <!-- Recap Time -->
                      <!-- <v-row>
                        <v-col class="my-n4">
                          <v-dialog
                            ref="dialog"
                            v-model="modal2"
                            :return-value.sync="recapTime"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="recapTime"
                                label="Waktu Rekap"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="modal2"
                              v-model="recapTime"
                              full-width
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="modal2 = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.dialog.save(recapTime)"
                              >
                                OK
                              </v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-col>
                      </v-row> -->
                      
                      <!-- Periodical Info -->
                      <!-- <v-row>
                        <v-col class="my-n4">
                          <v-text-field
                            v-model="period"
                            :rules="nameRules"
                            label="Periode Info (menit)"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row> -->
                      

                    </v-col>

                    <v-divider
                      class="d-none d-sm-flex"
                      vertical
                    ></v-divider>

                    <v-col
                      cols="12"
                      sm="6"
                    >
                    <v-row>
                      <v-col class="mb-n4">
                        <v-text-field
                          v-model="voltage"
                          :rules="number"
                          label="Low Voltage"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <!-- mm/tick -->
                    <!-- <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="tickmm"
                          :rules="number"
                          label="mm/tick"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row> -->

                    <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="dasarAir"
                          :rules="number"
                          label="Dasar Air"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="tinggiMaks"
                          :rules="number"
                          label="Tinggi Maksimum"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="titikNol"
                          :rules="number"
                          label="Titik Nol"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="nomorTelp"
                          readonly
                          label="Nomor Telfon"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="signal"
                          readonly
                          label="Signal"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="idDevice"
                          readonly
                          label="MAC Address"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        class="my-n4"
                      >
                        <v-text-field
                          v-model="password"
                          :rules="nameRules"
                          label="Password Petugas"
                          :type="show1 ? 'text' : 'password'"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="show1 = !show1"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    </v-col>

                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn
                        color="error darken-1"
                        @click="deleteDevice(selectStation)"
                      >
                        <v-icon>
                          mdi-delete
                        </v-icon>
                        Delete Device
                      </v-btn>
                      <v-btn
                        color="success darken-1"
                        class="float-right"
                        @click="save(selectStation)"
                      >
                        Save
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>

              <br>
              <v-row>
                <v-col>
                <h2> Tukar Device</h2>
                <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    v-model="stationA"
                    :items="stations"
                    label="Stasiun"
                    persistent-hint
                    return-object
                    :hint="stationA.feedingID">
                  </v-select>
                </v-col>
                <v-icon>mdi-swap-horizontal</v-icon>
                <v-col>
                  <v-select
                    v-model="stationB"
                    :items="stations"
                    label="Stasiun"
                    return-object
                    persistent-hint
                    :hint ="stationB.feedingID">
                    <template v-slot:append-outer>
                      <v-btn
                        color="success darken-1"
                        @click="swapDevice(stationA,stationB)"
                      >
                        Swap
                      </v-btn>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-snackbar
            v-model="swapSnackbar"
            color="success darken-1"
            dark
            bottom>
            Device Swapped
          </v-snackbar>
        </v-tab-item>

        <!-- Notification -->
        <v-tab-item>
          <v-card
            flat
          >
            <v-card-text>
              <v-form ref="notification" v-model="valid">
                <v-container>
                  
                  <!-- Formating Notification -->
                  <v-row>
                    <v-col
                      cols="12"
                    >
                    <Mentionable
                      :keys="['@']"
                      :items="suggestionsAlarm"
                      placement="bottom"
                      offset="5 100"
                    >
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label="Bahaya Notification Format"
                        v-model="bahayaNotif"
                      ></v-textarea>
                    </Mentionable>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                    <Mentionable
                      :keys="['@']"
                      :items="suggestionsAlarm"
                      placement="bottom"
                      offset="5 100"
                    >
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label="Evakuasi Notification Format"
                        v-model="evakuasiNotif"
                      ></v-textarea>
                    </Mentionable>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                    <Mentionable
                      :keys="['@']"
                      :items="suggestionsAlarm"
                      placement="bottom"
                      offset="5 100"
                    >
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label="Waspada Notification Format"
                        v-model="waspadaNotif"
                      ></v-textarea>
                    </Mentionable>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                    <Mentionable
                      :keys="['@']"
                      :items="suggestions"
                      placement="bottom"
                      offset="5 100"
                    >
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label="Battery Low Notification Format"
                        v-model="batteryNotif"
                      ></v-textarea>
                    </Mentionable>
                    </v-col>

                    <v-col
                      cols="12"
                    >
                    <Mentionable
                      :keys="['@']"
                      :items="suggestions"
                      placement="bottom"
                      offset="5 100"
                    >
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label="Device Status Notification Format"
                        v-model="turnedOnNotif"
                      ></v-textarea>
                    </Mentionable>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-btn
                        color="success darken-1"
                        class="float-right"
                        @click="saveNotif()"
                      >
                        Save
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>


      </v-tabs-items>
    </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>

import { db }from "@/firebase/db.js"
import firebase from "firebase/app"
// import Tiptap from '@/components/TipTap.vue'
// import _ from "lodash";
import { Mentionable } from 'vue-mention'

  export default {
    data : () => ({
      titikNol:null,
      idDevice:null,
      nomorTelp:null,
      signal:null,
      waspada:null,
      evakuasi:null,
      bahaya:null,
      dasarAir:null,
      tinggiMaks:null,
      bahayaNotif:'',
      bahayaNotifArray:{
        station:[],
        time:[],
        text:[],
        tinggi:[],
        satuan:[]
      },
      waspadaNotif:'',
      waspadaNotifArray:{
        station:[],
        time:[],
        tinggi:[],
        text:[],
        satuan:[]
      },
      evakuasiNotif:'',
      evakuasiNotifArray:{
        station:[],
        time:[],
        tinggi:[],
        text:[],
        satuan:[]
      },
      batteryNotif:'',
      batteryNotifArray:{
        station:[],
        time:[],
        text:[],
      },
      turnedOnNotif:'',
      turnedOnNotifArray:{
        station:[],
        time:[],
        text:[],
      },
      suggestionsAlarm: [
        {
          value: 'station',
          label: 'Stasiun',
        },
        {
          value: 'tinggi',
          label: 'Ketinggian'
        },
        {
          value: 'time',
          label: 'Waktu',
        },
        {
          value: 'satuan',
          label: 'Satuan',
        },
      ],
      suggestions: [
        {
          value: 'station',
          label: 'Stasiun',
        },
        {
          value: 'time',
          label: 'Waktu',
        },
      ],
      tab: null,
      items: [
        'Alarm', 'Notification'
      ],
      itemNotification: [
        {text:'Rain Start', value:'start'},
        {text:'Rain Stop', value:'stop'},
        {text:'Notif C', value:'notifc'},
        {text:'Notif A', value:'notifa'},
        {text:'Battery', value:'battery'},
        {text:'Device Status', value:'turnedon'},
      ],
      positions: [],
      locations:['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE'],
      search:null,
      searchLocation:null,
      roleRequired: [
        v => !!v || 'Role is required',
      ],
      locationRequired: [
        v => !!v || 'Location is required',
      ],
      stations:[],
      selectStation:null,
      station: null,
      phoneNumber:null,
      location: null,
      recapTime: null,
      period: null,
      tickmm: null,
      voltage: null,
      alarmA:null,
      alarmC:null,
      starttick:null,
      stoptime:null,
      valid:false,
      index:null,
      row:0,
      longitude: null,
      latitude:null,
      position:null,
      checkbox:false,
      selectedNotif:null,
      oldValue:{},
      modal2:false,
      nameRules: [
        v => !!v || 'This Field is required'
      ],
      pageRules: [
        v => v.length>0 || 'At least 1 page needs to be selected'
      ],
      number: [
        v => !!v || 'This Field is required',
        v => /^-?[0-9]*\.?[0-9]*$/.test(v) || 'Only number is allowed'
      ],
      selectedID:null,
      dialogDelete:false,
      emailDelete:null,
      text:'',
      password:'',
      show1:false,
      positionData:null,
      selectedPages:[],
      itemPages:[
        {text:'Peta', value:'Map'},
        {text: 'Peta GPS', value: 'MapGPS'},
        {text:'Kondisi Saat Ini', value:'Condition'},
        {text:'Kondisi Historis', value:'History'},
        {text:'Add Device', value:'AddDevice'},
        {text:'Administrator', value:'Administrator'},
        {text:'Notifikasi', value:'Notification'},
        {text:'Rekapitulasi', value:'Recap'},
        {text:'Grafik Rekapitulasi', value: 'Chart'},
        {text: 'Grafik TMA', value:'ChartTMA'},
        {text: 'Log File', value: 'DownloadFile'},
        {text: 'Log File Bulanan', value: 'DownloadFileMonthly'}
      ],
      checkboxData: false,
      roleCombobox:null,
      stationA: {
        newID: null,
        feedingID:null
      },
      stationB: {
        newID: null,
        feedingID:null
      },
      swapSnackbar:false,
    }),
    components: {
      // Tiptap
      Mentionable,
    },
    async mounted() {
      let loader = this.$loading.show()
      if (localStorage.getItem("role")=='Petugas') {
        let device = localStorage.getItem('device')
        this.$router.push(`/MapPetugas-id=${device}&device=${localStorage.getItem('jenis')}`)
      }
      var settingRef = db.collection('radar')
      await settingRef.orderBy("station","asc").onSnapshot((collectionSnapshot) => {
        this.stations=[]
        this.data=[]
        collectionSnapshot.forEach((doc) => {  
          if (doc.data().location=='MARNOV') {
            if (localStorage.getItem('location')=='MARNOV') {
              this.stations.push({text: doc.data().station, value: doc.id, newID: doc.data().newID?doc.data().newID:doc.id, feedingID:doc.data().feedingID?doc.data().feedingID:doc.data().newID?doc.data().newID:doc.id});
              this.data.push({id: doc.id, ...doc.data()});
            }
          } else {
            this.stations.push({text: doc.data().station, value: doc.id, newID: doc.data().newID?doc.data().newID:doc.id, feedingID:doc.data().feedingID?doc.data().feedingID:doc.data().newID?doc.data().newID:doc.id});
            this.data.push({id: doc.id, ...doc.data()});
          }
        });
        this.loadingData=false
        loader.hide()
      })
      
      await db.collection('notificationSetRadar').onSnapshot((collectionSnapshot) => {
        collectionSnapshot.forEach((doc) => {
          if (doc.id=='bahaya') {
            this.bahayaNotif=this.textConstructor(doc.data())
          }
          if (doc.id=='evakuasi') {
            this.evakuasiNotif=this.textConstructor(doc.data())
          }
          if (doc.id=='waspada') {
            this.waspadaNotif=this.textConstructor(doc.data())
          }
          if (doc.id=='turnedOn') {
            this.turnedOnNotif=this.textConstructor(doc.data())
          }
          if (doc.id=='battery') {
            this.batteryNotif=this.textConstructor(doc.data())
          }
        })
      })
    },
    methods: {
      async swapDevice (stationA,stationB) {
        if (stationA.value==stationB.value) {
          alert('Device A and Device B cannot be the same!')
          return
        }
        if (stationA.newID==null || stationB.newID==null) {
          alert('Please fill the new ID for both devices!')
          return
        }

        let loader=this.$loading.show()
        let deviceA=stationA.value
        let deviceB=stationB.value
        let feedingIDA=stationA.feedingID
        let feedingIDB=stationB.feedingID


        let updateNewIDA = null;
        let updateNewIDB = null;
        let lastFeedingIDfeederA = null;
        let lastFeedingIDfeederB = null;


        await db.collection('radar').doc(feedingIDA).get().then((doc) => {
          updateNewIDA = doc.data().newID?doc.data().newID:doc.id
          lastFeedingIDfeederA = doc.data().feedingID?doc.data().feedingID:doc.data().newID?doc.data().newID:doc.id
        })

        await db.collection('radar').doc(feedingIDB).get().then((doc) => {
          updateNewIDB = doc.data().newID?doc.data().newID:doc.id
          lastFeedingIDfeederB = doc.data().feedingID?doc.data().feedingID:doc.data().newID?doc.data().newID:doc.id
        })

        await db.collection('radar').doc(feedingIDA).update({
          newID:updateNewIDB,
          feedingID:lastFeedingIDfeederA
        })

        await db.collection('radar').doc(feedingIDB).update({
          newID:updateNewIDA,
          feedingID:lastFeedingIDfeederB
        })

        let tempDataA = {}
        await db.collection('radar').doc(deviceA).get().then((doc) => {
          tempDataA = {
            newVersion: doc.data().newVersion,
            calibM: doc.data().calibM,
            calibB:doc.data().calibB,
            periodic:doc.data().periodic,
            wakeUp:doc.data().wakeUp,
            calibBat:doc.data().calibBat,
            offset: doc.data().offset,
            satuan: doc.data().satuan,
            requestFile: doc.data().requestFile,
            requestFileTime: doc.data().requestFileTime,
            CRC32: doc.data().CRC32,
          }
        })

        let tempDataB = {}
        await db.collection('radar').doc(deviceB).get().then((doc) => {
          tempDataB = {
            newVersion: doc.data().newVersion,
            calibM: doc.data().calibM,
            calibB:doc.data().calibB,
            periodic:doc.data().periodic,
            wakeUp:doc.data().wakeUp,
            calibBat:doc.data().calibBat,
            offset: doc.data().offset,
            satuan: doc.data().satuan,
            requestFile: doc.data().requestFile,
            requestFileTime: doc.data().requestFileTime,
            CRC32: doc.data().CRC32,
          }
        })

        await db.collection('radar').doc(deviceB).update({
          newVersion: tempDataA.newVersion,
          calibM: tempDataA.calibM,
          calibB: tempDataA.calibB,
          periodic: tempDataA.periodic,
          wakeUp: tempDataA.wakeUp,
          calibBat: tempDataA.calibBat,
          offset: tempDataA.offset,
          satuan: tempDataA.satuan,
          requestFile: tempDataA.requestFile,
          requestFileTime: tempDataA.requestFileTime,
          CRC32: tempDataA.CRC32,
          feedingID: feedingIDA
        })

        await db.collection('radar').doc(deviceA).update({
          newVersion: tempDataB.newVersion,
          calibM: tempDataB.calibM,
          calibB: tempDataB.calibB,
          periodic: tempDataB.periodic,
          wakeUp: tempDataB.wakeUp,
          calibBat: tempDataB.calibBat,
          offset: tempDataB.offset,
          satuan: tempDataB.satuan,
          requestFile: tempDataB.requestFile,
          requestFileTime: tempDataB.requestFileTime,
          CRC32: tempDataB.CRC32,
          feedingID: feedingIDB
        }).then(() => {
          this.stationA.feedingID= feedingIDB
          this.stationB.feedingID= feedingIDA
          loader.hide()
          this.swapSnackbar=true
        })        
      },
      change(station) {
        this.index = this.data.findIndex(x => x.id === station.value);
        this.station=station.text
        this.waspada = this.data[this.index].waspada_setting
        this.evakuasi = this.data[this.index].evakuasi_setting
        this.bahaya = this.data[this.index].bahaya_setting
        this.voltage = this.data[this.index].voltLow
        this.dasarAir = this.data[this.index].dasarAir
        this.tinggiMaks = this.data[this.index].tinggiMaks
        this.location = this.data[this.index].location
        this.latitude = this.data[this.index].latitude
        this.longitude = this.data[this.index].longitude
        this.signal = this.data[this.index].signal
        this.nomorTelp = this.data[this.index].nomor
        this.idDevice = station.value
        this.titikNol = this.data[this.index].titikNol
        this.password = this.data[this.index].password
        // var deviceRef = db.collection('device').doc(station.value)
        // deviceRef.get().then((doc) =>{
        //   this.location=doc.data().location
        //   this.latitude=doc.data().latitude
        //   this.longitude=doc.data().longitude
        //   this.phoneNumber = doc.data().phoneNumber
        //   this.password = doc.data().password
        // }) 
      },
      async save(station) {
        if (this.$refs.form.validate()) {
          let loader=this.$loading.show()
          var deviceRef = db.collection('radar').doc(station.value)
          await deviceRef.update({
            location : this.location,
            latitude : this.latitude,
            longitude : this.longitude,
            station: this.station,
            // phoneNumber: this.phoneNumber,
            // password: this.password
            waspada_setting : this.waspada,
            evakuasi_setting : this.evakuasi,
            bahaya_setting : this.bahaya,
            voltLow : this.voltage,
            dasarAir : this.dasarAir,
            tinggiMaks : this.tinggiMaks,
            titikNol: this.titikNol,
            password: this.password
          }).then(()=> {
            loader.hide()
          })
          
        }
        
      },
      saveNotif() {
        if(this.$refs.notification.validate()) {
          // Get a new write batch
          var batch = db.batch();
          var startRef = db.collection('notificationSetRadar').doc('bahaya')
          batch.set(startRef,{
            station: this.bahayaNotifArray.station,
            time: this.bahayaNotifArray.time,
            tinggi: this.bahayaNotifArray.tinggi,
            satuan: this.bahayaNotifArray.satuan,
            text: this.bahayaNotifArray.text
          })
          var stopRef = db.collection('notificationSetRadar').doc('waspada')
          batch.set(stopRef,{
            station: this.waspadaNotifArray.station,
            time: this.waspadaNotifArray.time,
            tinggi: this.waspadaNotifArray.tinggi,
            satuan: this.waspadaNotifArray.satuan,
            text: this.waspadaNotifArray.text
          })
          var notifARef = db.collection('notificationSetRadar').doc('evakuasi')
          batch.set(notifARef,{
            station: this.evakuasiNotifArray.station,
            time: this.evakuasiNotifArray.time,
            tinggi: this.evakuasiNotifArray.tinggi,
            satuan: this.evakuasiNotifArray.satuan,
            text: this.evakuasiNotifArray.text
          })
          var batteryRef = db.collection('notificationSetRadar').doc('battery')
          batch.set(batteryRef,{
            station: this.batteryNotifArray.station,
            time: this.batteryNotifArray.time,
            text: this.batteryNotifArray.text
          })
          var turnedOnRef = db.collection('notificationSetRadar').doc('turnedOn')
          batch.set(turnedOnRef,{
            station: this.turnedOnNotifArray.station,
            time: this.turnedOnNotifArray.time,
            text: this.turnedOnNotifArray.text
          })
          batch.commit().then(() => {
            console.log("Notification Updated")
          })
        }
      },
      textConstructor(format) {
        let text=''
        let text_length=format.text.length
        if (typeof format.station !== 'undefined') {
          text_length += format.station.length
        }
        if (typeof format.time !== 'undefined') {
          text_length += format.time.length
        }
        if (typeof format.tinggi !== 'undefined') {
          text_length += format.tinggi.length
        }

        if (typeof format.satuan !== 'undefined') {
          text_length += format.satuan.length
        }

        let textArray=[]
        for (let i=0; i<text_length; i++) {
          let j=0;
          let k=0;
          let l=0;
          let m=0;
          if (typeof format.station !== 'undefined') {
            if (i == format.station[j]) {
              textArray.push('@station')
              j++;
            }
          }
          if (typeof format.time !== 'undefined') {
            if (i == format.time[k]) {
              textArray.push('@time')
              k++;
            }
          }
          if (typeof format.tinggi !== 'undefined') {
            if (i == format.tinggi[l]) {
              textArray.push('@tinggi')
              l++;
            }
          }
          if (typeof format.satuan !== 'undefined') {
            if (i == format.satuan[m]) {
              textArray.push('@satuan')
              m++;
            }
          }
          textArray.push(format.text[i])
          if (textArray[i]!= undefined) {
            text= text.concat(textArray[i])
          }
          
        }
        return text
      },
      async deleteDevice(ID) {
        if (ID.value.includes('BBWS_TMA')) {
          await db.collection("radar").doc(ID.value).delete().then(() => {
              console.log("Document successfully deleted!");
          }).catch((error) => {
              console.error("Error removing document: ", error);
          });
          await db.collection("BBWS_Connector").doc("BBWS_TMA").update({
            IDs: firebase.firestore.FieldValue.arrayRemove(ID.value)
          })
        } else {
          await db.collection("radar").doc(ID.value).update({
            station: firebase.firestore.FieldValue.delete(),
            bahaya: firebase.firestore.FieldValue.delete(),
            evakuasi: firebase.firestore.FieldValue.delete(),
            location: firebase.firestore.FieldValue.delete(),
            waspada: firebase.firestore.FieldValue.delete(),
            timestamp: firebase.firestore.FieldValue.delete(),
          }).then(() => {
              console.log("Document successfully deleted!");
          }).catch((error) => {
              console.error("Error removing document: ", error);
          });
        }
      },
      async saveNotifRole() {
        if (this.$refs.notif.validate()) {
          let loader=this.$loading.show()
          await db.collection('roleNotification').doc(this.position).set({
            notif:this.selectedNotif,
            location:this.checkbox
          }).then(() => {
            loader.hide()
            this.selectedNotif=[]
            this.checkbox=false
            this.position=null
          })
        }
      },
      async getRoleNotif(position) {
        await db.collection('roleNotification').doc(position).get().then((doc) => {
          this.selectedNotif = doc.data().notif
          this.checkbox = doc.data().location
        })
      },
      async getRoleData(position) {
        await db.collection('roleSetting').doc(position).get().then((doc) => {
          this.selectedPages=doc.data().page
          this.checkboxData=doc.data().location
        })
      },
      async saveDataSetting() {
        if (this.$refs.dataSetting.validate()) {
          let loader= this.$loading.show()
          await db.collection('roleSetting').doc(this.positionData).set({
            location:this.checkboxData,
            page:this.selectedPages
          }).then(() => {
            this.checkboxData=false
            this.selectedPages=[]
            loader.hide()
          }).catch(() => {
            loader.hide()
          })
        }
        
      },
      async saveRole(ID,role) {
        let loader= this.$loading.show()
        await db.collection('user').doc(ID).update({
          role:role
        }).then(() => {
          loader.hide()
        }).catch(() => {
          loader.hide()
        })
      },
      async saveLocation(ID,location) {
        let loader= this.$loading.show()
        await db.collection('user').doc(ID).update({
          location:location
        }).then(() => {
          loader.hide()
        }).catch(() => {
          loader.hide()
        })
      },
      filterItems(arr, query) {
        return arr.filter(function(el) {
          console.log(el)
          return (el.toLowerCase().indexOf(query.toLowerCase()) !== -1)
        })
      },
      async deleteRole (role) {
        let found = this.users.findIndex(x=> x.role === role)
        // No user with the selected role
        if (found==-1) {
          let index = this.positions.findIndex(x=> x===role)
          this.positions.splice(index,1)
          let loader=this.$loading.show()
          await db.collection("user").doc('role').update({
            roles:this.positions
          }).catch(() => {
            loader.hide()
          });
          await db.collection('roleNotification').doc(role).delete().catch(()=> {
            loader.hide()
          })
          await db.collection('roleSetting').doc(role).delete().then(() => {
            loader.hide()
          }).catch(() => {
            loader.hide()
          })
        } else {
          alert('Terdapat user yang memiliki role tersebut!')
        }
      }
    },
    watch: {
      bahayaNotif(val) {
        this.bahayaNotifArray.text=val.split('@')
        this.bahayaNotifArray.station=[]
        this.bahayaNotifArray.time=[]
        this.bahayaNotifArray.tinggi=[]
        this.bahayaNotifArray.satuan=[]
        for (let i=0; i<this.bahayaNotifArray.text.length; i++) {
          if (this.bahayaNotifArray.text[i].startsWith("station")) {
            this.bahayaNotifArray.text[i]=this.bahayaNotifArray.text[i].slice(7)
            this.bahayaNotifArray.station.push(i)
          }
          if (this.bahayaNotifArray.text[i].startsWith("time")) {
            this.bahayaNotifArray.text[i]=this.bahayaNotifArray.text[i].slice(4)
            this.bahayaNotifArray.time.push(i)
          }
          if (this.bahayaNotifArray.text[i].startsWith("tinggi")) {
            this.bahayaNotifArray.text[i]=this.bahayaNotifArray.text[i].slice(6)
            this.bahayaNotifArray.tinggi.push(i)
          }
          if (this.bahayaNotifArray.text[i].startsWith("satuan")) {
            this.bahayaNotifArray.text[i]=this.bahayaNotifArray.text[i].slice(6)
            this.bahayaNotifArray.satuan.push(i)
          }
        }
      },
      waspadaNotif(val) {
        this.waspadaNotifArray.text=val.split('@')
        this.waspadaNotifArray.station=[]
        this.waspadaNotifArray.time=[]
        this.waspadaNotifArray.tinggi=[]
        this.waspadaNotifArray.satuan=[]
        for (let i=0; i<this.waspadaNotifArray.text.length; i++) {
          if (this.waspadaNotifArray.text[i].startsWith("station")) {
            this.waspadaNotifArray.text[i]=this.waspadaNotifArray.text[i].slice(7)
            this.waspadaNotifArray.station.push(i)
          }
          if (this.waspadaNotifArray.text[i].startsWith("time")) {
            this.waspadaNotifArray.text[i]=this.waspadaNotifArray.text[i].slice(4)
            this.waspadaNotifArray.time.push(i)
          }
          if (this.waspadaNotifArray.text[i].startsWith("tinggi")) {
            this.waspadaNotifArray.text[i]=this.waspadaNotifArray.text[i].slice(6)
            this.waspadaNotifArray.tinggi.push(i)
          }
          if (this.waspadaNotifArray.text[i].startsWith("satuan")) {
            this.waspadaNotifArray.text[i]=this.waspadaNotifArray.text[i].slice(6)
            this.waspadaNotifArray.satuan.push(i)
          }
        }
      },
      evakuasiNotif(val) {
        this.evakuasiNotifArray.text=val.split('@')
        this.evakuasiNotifArray.station=[]
        this.evakuasiNotifArray.time=[]
        this.evakuasiNotifArray.tinggi=[]
        this.waspadaNotifArray.satuan=[]
        for (let i=0; i<this.evakuasiNotifArray.text.length; i++) {
          if (this.evakuasiNotifArray.text[i].startsWith("station")) {
            this.evakuasiNotifArray.text[i]=this.evakuasiNotifArray.text[i].slice(7)
            this.evakuasiNotifArray.station.push(i)
          }
          if (this.evakuasiNotifArray.text[i].startsWith("time")) {
            this.evakuasiNotifArray.text[i]=this.evakuasiNotifArray.text[i].slice(4)
            this.evakuasiNotifArray.time.push(i)
          }
          if (this.evakuasiNotifArray.text[i].startsWith("tinggi")) {
            this.evakuasiNotifArray.text[i]=this.evakuasiNotifArray.text[i].slice(6)
            this.evakuasiNotifArray.tinggi.push(i)
          }
          if (this.evakuasiNotifArray.text[i].startsWith("satuan")) {
            this.evakuasiNotifArray.text[i]=this.evakuasiNotifArray.text[i].slice(6)
            this.evakuasiNotifArray.satuan.push(i)
          }
        }
      },
      batteryNotif(val) {
        this.batteryNotifArray.text=val.split('@')
        this.batteryNotifArray.station=[]
        this.batteryNotifArray.time=[]
        for (let i=0; i<this.batteryNotifArray.text.length; i++) {
          if (this.batteryNotifArray.text[i].startsWith("station")) {
            this.batteryNotifArray.text[i]=this.batteryNotifArray.text[i].slice(7)
            this.batteryNotifArray.station.push(i)
          }
          if (this.batteryNotifArray.text[i].startsWith("time")) {
            this.batteryNotifArray.text[i]=this.batteryNotifArray.text[i].slice(4)
            this.batteryNotifArray.time.push(i)
          }
        }
      },
      turnedOnNotif(val) {
        this.turnedOnNotifArray.text=val.split('@')
        this.turnedOnNotifArray.station=[]
        this.turnedOnNotifArray.time=[]
        for (let i=0; i<this.turnedOnNotifArray.text.length; i++) {
          if (this.turnedOnNotifArray.text[i].startsWith("station")) {
            this.turnedOnNotifArray.text[i]=this.turnedOnNotifArray.text[i].slice(7)
            this.turnedOnNotifArray.station.push(i)
          }
          if (this.turnedOnNotifArray.text[i].startsWith("time")) {
            this.turnedOnNotifArray.text[i]=this.turnedOnNotifArray.text[i].slice(4)
            this.turnedOnNotifArray.time.push(i)
          }
        }
      },
      async roleCombobox (val, prev) {
        val = val != null ? val : ''
        prev = prev != null ? prev : ''
        if (val.length === prev.length) return
        if (val!== '') {
          if (this.filterItems(this.positions,val).length==0) {
            if (val!=null) {
              this.positions.push(val)
              await db.collection('roleNotification').doc(val).set({
                location:false,
                notif:['start','stop','notifc','notifa','battery','turnedon']
              })
              await db.collection('roleSetting').doc(val).set({
                location:false,
                page:['Map','Condition','History','Notification','Recap']
              })
            }
            var userRef = db.collection('user')
            if (this.positions.indexOf(null)===-1) {
              await userRef.doc('role').set({
                roles:this.positions,
                confirmed:true
              })
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss">
.tooltip {
  display: block !important;
  z-index: 10000;
  position:'bottom-end';
  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }
  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 50px;
    border-color: black;
    z-index: 1;
  }
  &[x-placement^="top"] {
    margin-bottom: 5px;
    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="bottom"] {
    margin-top: 5px;
    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="right"] {
    margin-left: 5px;
    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[x-placement^="left"] {
    margin-right: 5px;
    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }
  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
  &.info {
    $color: rgba(#004499, .9);
    .tooltip-inner {
      background: $color;
      color: white;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }
    .tooltip-arrow {
      border-color: $color;
    }
  }
  &.popover {
    $color: #3949ab;
    .popover-inner {
      background: $color;
      color: rgb(255, 255, 255);
      padding: 4px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }
    .popover-arrow {
      border-color: $color;
    }
  }
  
}
</style>

<style>
.mention-item {
  padding: 4px 10px;
  border-radius: 4px;
}

.mention-selected {
  background:#6875bf;
}
</style>
